// target: assets/pl2.js — Personliga interactivity (vanilla, no framework)
(function () {
  'use strict';
  /* This file is referenced by several sections (header, UGC wall, product…), so the browser
     runs it once per section. Without a guard every handler bound 2–3× — the sound toggle
     fired twice per click and cancelled itself, mega-menu clicks opened then closed. */
  if (window.__pl2Init) return; window.__pl2Init = true;
  var I18N = window.PL2_I18N || {};
  function T(k, fb) { return (I18N[k] != null) ? I18N[k] : fb; }
  function fmt(tpl, v) { return String(tpl).replace('%s', v); }
  function ready(fn) { document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    /* ---------- Mega menu ---------- */
    var header = document.querySelector('[data-pl2-header]');
    if (header) {
      var panels = header.querySelectorAll('[data-pl2-panel]');
      var triggers = header.querySelectorAll('[data-pl2-mega]');
      function closeAll() {
        panels.forEach(function (p) { p.classList.remove('is-open'); });
        triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      }
      triggers.forEach(function (t) {
        var key = t.getAttribute('data-pl2-mega');
        function open() {
          closeAll();
          var p = header.querySelector('[data-pl2-panel="' + key + '"]');
          if (p) { p.classList.add('is-open'); t.setAttribute('aria-expanded', 'true'); }
        }
        t.addEventListener('mouseenter', open);
        t.addEventListener('click', function () {
          var p = header.querySelector('[data-pl2-panel="' + key + '"]');
          if (p && p.classList.contains('is-open')) closeAll(); else open();
        });
      });
      header.querySelectorAll('[data-pl2-close-mega]').forEach(function (el) {
        el.addEventListener('mouseenter', closeAll);
      });
      header.addEventListener('mouseleave', closeAll);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
    }

    /* ---------- Mobile drawer + accordions ---------- */
    var drawer = document.querySelector('[data-pl2-drawer]');
    if (drawer) {
      var openBtn = document.querySelector('[data-pl2-drawer-open]');
      function setDrawer(open) {
        drawer.classList.toggle('is-open', open);
        document.documentElement.style.overflow = open ? 'hidden' : '';
        if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      if (openBtn) openBtn.addEventListener('click', function () { setDrawer(true); });
      drawer.querySelectorAll('[data-pl2-drawer-close]').forEach(function (el) {
        el.addEventListener('click', function () { setDrawer(false); });
      });
      drawer.querySelectorAll('[data-pl2-acc]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var body = btn.nextElementSibling;
          if (!body) return;
          var willOpen = !body.classList.contains('is-open');
          drawer.querySelectorAll('.pl2-acc__body.is-open').forEach(function (b) { b.classList.remove('is-open'); });
          body.classList.toggle('is-open', willOpen);
        });
      });
    }

    /* ---------- UGC video sound toggle (exclusive) ---------- */
    document.querySelectorAll('[data-pl2-sound]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var wrap = chip.closest('[data-pl2-video]');
        var v = wrap && wrap.querySelector('video');
        if (!v) return;
        var wasMuted = v.muted;
        document.querySelectorAll('[data-pl2-video] video').forEach(function (o) { o.muted = true; o.removeAttribute('data-pl2-unmuted'); });
        document.querySelectorAll('[data-pl2-sound]').forEach(function (c) { c.textContent = T('soundOff', '🔇 Ljud'); });
        if (wasMuted) {
          v.muted = false; v.volume = 1; v.setAttribute('data-pl2-unmuted', '1'); chip.textContent = T('soundOn', '🔊 Ljud på');
          var p = v.play(); if (p && p.catch) p.catch(function () {});   /* a paused card must start playing when sound is turned on */
        }
      });
    });
    // Autoplay nudge for muted loops
    document.querySelectorAll('[data-pl2-video] video, .pl2-vsplit__video video').forEach(function (v) {
      v.muted = true;
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    });

    /* ---------- Product gallery (keeps Dawn/Customily data-media-id) ---------- */
    document.querySelectorAll('media-gallery.pl2-gallery').forEach(function (gal) {
      var thumbs = gal.querySelectorAll('[data-pl2-thumb]');
      thumbs.forEach(function (th) {
        th.addEventListener('click', function () {
          var id = th.getAttribute('data-target-media');
          gal.querySelectorAll('.pl2-gallery__item').forEach(function (it) {
            var on = it.getAttribute('data-media-id') === id;
            it.classList.toggle('is-active', on);
            var vid = it.querySelector('video');
            if (vid) { if (on) { vid.muted = true; var p = vid.play(); if (p && p.catch) p.catch(function(){}); } else vid.pause(); }
          });
          thumbs.forEach(function (t) { t.classList.toggle('is-active', t === th); });
        });
      });
    });

    /* ---------- Variant sync: hidden id + displayed prices follow the REAL selected variant.
       (Store layer, 2026-08-17: the tier cards are radio inputs of a real product option, so
        selecting one is a variant change — prices come from product.variants, never typed in.) ---------- */
    function pl2Money(cents) {
      var fmt = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'SEK';
      try {
        var loc = ({ sv: 'sv-SE', de: 'de-DE', nl: 'nl-NL', da: 'da-DK', nb: 'nb-NO', fi: 'fi-FI', en: 'en-GB' })[T('locale', 'sv')] || 'sv-SE';
        var s = new Intl.NumberFormat(loc, { style: 'currency', currency: fmt, minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(cents / 100);
        return s.replace(/ kr$/, ' kr');
      } catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' kr'; }
    }
    document.querySelectorAll('[data-pl2-variants]').forEach(function (vs) {
      var jsonEl = vs.querySelector('script[type="application/json"]');
      if (!jsonEl) return;
      var variants;
      try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }
      var section = vs.getAttribute('data-section');
      var form = document.getElementById('product-form-' + section);
      var idInput = form && form.querySelector('input.product-variant-id');
      var submit = form && form.querySelector('.product-form__submit');

      function selectedValues() {
        var selected = [];
        vs.querySelectorAll('fieldset').forEach(function (fs) {
          var checked = fs.querySelector('input:checked');
          selected.push(checked ? checked.value : null);
        });
        return selected;
      }
      function paintTiers() {
        var selected = selectedValues();
        vs.querySelectorAll('[data-pl2-tier]').forEach(function (lbl) {
          var input = document.getElementById(lbl.getAttribute('for'));
          lbl.classList.toggle('is-active', !!(input && input.checked));
          /* repaint this card's price for the currently selected OTHER options (e.g. size) */
          var oi = parseInt(lbl.getAttribute('data-opt-index'), 10), ov = lbl.getAttribute('data-opt-value');
          if (isNaN(oi)) return;
          var want = selected.slice(); want[oi] = ov;
          var v = variants.find(function (x) { return want.every(function (val, i) { return val === null || x.options[i] === val; }); });
          var pEl = lbl.querySelector('[data-pl2-tier-price]'), sEl = lbl.querySelector('[data-pl2-tier-save]');
          if (v && pEl) pEl.textContent = pl2Money(v.price);
          if (v && sEl) sEl.textContent = (v.compare_at_price > v.price) ? fmt(T('save', 'Spara %s'), pl2Money(v.compare_at_price - v.price)) : '';
          lbl.classList.toggle('is-unavailable', !!(v && !v.available));
        });
      }
      function sync() {
        var selected = selectedValues();
        var match = variants.find(function (v) {
          return selected.every(function (val, i) { return val === null || v.options[i] === val; });
        });
        paintTiers();
        if (!match) {
          if (submit) { submit.disabled = true; submit.querySelector('span') && (submit.querySelector('span').textContent = T('unavailable', 'Ej tillgänglig')); }
          return;
        }
        if (idInput && idInput.value !== String(match.id)) {
          idInput.value = match.id;
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        var now = pl2Money(match.price);
        var was = match.compare_at_price && match.compare_at_price > match.price ? pl2Money(match.compare_at_price) : '';
        document.querySelectorAll('[data-pl2-price-now]').forEach(function (el) { el.textContent = now; });
        document.querySelectorAll('[data-pl2-price-was]').forEach(function (el) { el.textContent = was; el.style.display = was ? '' : 'none'; });
        document.querySelectorAll('[data-pl2-save]').forEach(function (el) {
          if (was) { el.textContent = fmt(T('youSave', 'Du sparar %s 🎉'), pl2Money(match.compare_at_price - match.price)); el.style.display = ''; }
          else el.style.display = 'none';
        });
        if (submit) {
          submit.disabled = !match.available;
          var span = submit.querySelector('span');
          if (span && !match.available) span.textContent = T('soldOut', 'Slutsåld');
        }
        // keep the URL variant param in sync so refresh/share keeps the choice (Dawn behaviour)
        try { var u = new URL(window.location.href); u.searchParams.set('variant', match.id); history.replaceState({}, '', u); } catch (e) {}
        document.dispatchEvent(new CustomEvent('pl2:variant', { detail: { variant: match } }));
      }
      vs.addEventListener('change', function () { setTimeout(sync, 10); });
      sync();
    });

    /* ---------- Sticky ATC (mobile) ----------
       Customily clones the real add button and binds a click handler that preventDefaults,
       validates its required options and runs its own add-to-cart. Submitting the form
       directly bypasses that, and Customily's fetch wrapper then drops the /cart/add call
       silently. So: forward the tap to whatever button is actually in the form. */
    document.querySelectorAll('[data-pl2-sticky-atc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var form = document.getElementById(btn.getAttribute('data-pl2-sticky-atc'));
        if (!form) return;
        var real = form.querySelector('button[name="add"], [name="add"]');
        if (!real) {
          var wrap = form.closest('product-form') || document;
          real = wrap.querySelector('button[name="add"], [name="add"]');
        }
        if (real && !real.disabled) { real.click(); return; }
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      });
    });

    /* ---------- Cart drawer (Claude Design "Varukorg-Drawer", ported 2026-08-20) ---------- */
    var cartRoot = document.querySelector('[data-pl2-cart]');
    if (cartRoot) {
      var lastFocus = null;
      function setCart(open) {
        if (open) lastFocus = document.activeElement;
        cartRoot.hidden = !open;
        document.documentElement.style.overflow = open ? 'hidden' : '';
        if (open) {
          var c = cartRoot.querySelector('.pl2-cartdrawer__close');
          if (c) c.focus();
        } else if (lastFocus && lastFocus.focus) {
          lastFocus.focus();
        }
      }
      document.querySelectorAll('.pl2-iconbtn--cart').forEach(function (btn) {
        btn.addEventListener('click', function (e) { e.preventDefault(); setCart(true); });
      });
      function bindCart() {
        cartRoot.querySelectorAll('[data-pl2-cart-close]').forEach(function (el) {
          el.addEventListener('click', function () { setCart(false); });
        });
        cartRoot.querySelectorAll('[data-pl2-cart-qty],[data-pl2-cart-remove]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var line = parseInt(btn.getAttribute('data-line'), 10);
            var item = btn.closest('.pl2-cartdrawer__item');
            var qtyEl = item && item.querySelector('.qty span');
            var current = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
            var next = btn.hasAttribute('data-pl2-cart-remove') ? 0 : Math.max(0, current + parseInt(btn.getAttribute('data-pl2-cart-qty'), 10));
            btn.disabled = true;
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ line: line, quantity: next })
            }).then(function () {
              return fetch('/?sections=pl2-cart-drawer');
            }).then(function (r) { return r.json(); }).then(function (data) {
              var html = data['pl2-cart-drawer'];
              if (!html) return;
              var tmp = document.createElement('div');
              tmp.innerHTML = html;
              var fresh = tmp.querySelector('[data-pl2-cart]');
              if (fresh) { cartRoot.innerHTML = fresh.innerHTML; bindCart(); }
              var count = cartRoot.querySelector('.pl2-cartdrawer__title .count');
              if (count) {
                var n = count.textContent.replace(/[()]/g, '');
                document.querySelectorAll('.pl2-cart-count').forEach(function (c) { c.textContent = n; });
              }
            }).catch(function () { btn.disabled = false; });
          });
        });
      }
      /* The Essential free-shipping app injects its card into form[action="/cart"], which is our
         checkout form down in the footer. Move it under the header so it reads like the live theme.
         We only relocate the app's node — its markup and copy are left untouched. */
      function liftShipCard() {
        var slot = cartRoot.querySelector('[data-pl2-ship-slot]');
        if (!slot) return;
        var card = cartRoot.querySelector('[class*="free_shipping_card_wrapper"]');
        if (card && card.parentElement !== slot) slot.appendChild(card);
      }
      new MutationObserver(liftShipCard).observe(cartRoot, { childList: true, subtree: true });
      liftShipCard();

      bindCart();
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !cartRoot.hidden) setCart(false); });
      /* Dawn and Customily both announce a completed add-to-cart; re-render and open on either. */
      function refreshAndOpen() {
        fetch('/?sections=pl2-cart-drawer').then(function (r) { return r.json(); }).then(function (data) {
          var html = data['pl2-cart-drawer'];
          if (!html) return;
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('[data-pl2-cart]');
          if (fresh) { cartRoot.innerHTML = fresh.innerHTML; bindCart(); }
          var count = cartRoot.querySelector('.pl2-cartdrawer__title .count');
          if (count) {
            var n = count.textContent.replace(/[()]/g, '');
            document.querySelectorAll('.pl2-cart-count').forEach(function (c) { c.textContent = n; });
          }
          setCart(true);
        }).catch(function () {});
      }
      document.addEventListener('cart:refresh', refreshAndOpen);
      document.addEventListener('customily:added-to-cart', refreshAndOpen);
      /* last resort: watch /cart/add.js completions we did not originate */
      (function () {
        var origFetch = window.fetch;
        window.fetch = function () {
          var url = arguments[0] && (arguments[0].url || arguments[0]);
          var p = origFetch.apply(this, arguments);
          if (typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
            p.then(function (r) { if (r && r.ok) setTimeout(refreshAndOpen, 300); }).catch(function () {});
          }
          return p;
        };
      })();
    }

    /* ---------- FAQ search + category filter ---------- */
    var faqRoot = document.querySelector('[data-pl2-faq]');
    if (faqRoot) {
      var q = '', cat = 'alla';
      var items = faqRoot.querySelectorAll('[data-faq]');
      var empty = faqRoot.querySelector('[data-pl2-faq-empty]');
      function apply() {
        var visible = 0;
        items.forEach(function (el) {
          var okCat = cat === 'alla' || el.getAttribute('data-cat') === cat;
          var okQ = !q || el.textContent.toLowerCase().indexOf(q) !== -1;
          var show = okCat && okQ;
          el.style.display = show ? '' : 'none';
          if (show) visible++;
        });
        if (empty) empty.classList.toggle('is-visible', visible === 0);
      }
      var search = faqRoot.querySelector('[data-pl2-faq-search]');
      if (search) search.addEventListener('input', function () { q = search.value.trim().toLowerCase(); apply(); });
      faqRoot.querySelectorAll('[data-pl2-faq-cat]').forEach(function (pill) {
        pill.addEventListener('click', function () {
          cat = pill.getAttribute('data-pl2-faq-cat');
          faqRoot.querySelectorAll('[data-pl2-faq-cat]').forEach(function (p) {
            p.classList.toggle('is-active', p === pill);
          });
          apply();
        });
      });
    }
  });
})();

/* PL2 media kick (store layer): some browsers/panes never start autoplay for videos
   that were not in view at load, and pause them when hidden. Play whatever is on
   screen, pause the rest, and retry once the document becomes visible. */
(function () {
  function kick() {
    document.querySelectorAll('[data-pl2-video] video, .pl2-vsplit__video video').forEach(function (v) {
      var r = v.getBoundingClientRect();
      var onScreen = r.bottom > 0 && r.top < innerHeight;
      if (onScreen) { if (!v.hasAttribute('data-pl2-unmuted')) v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else if (!v.paused && !v.hasAttribute('data-pl2-unmuted')) v.pause();
    });
  }
  ['scroll', 'resize', 'visibilitychange', 'pageshow', 'DOMContentLoaded', 'load'].forEach(function (ev) { (ev === 'visibilitychange' || ev === 'DOMContentLoaded' ? document : window).addEventListener(ev, kick, { passive: true }); });
  setTimeout(kick, 800);
})();
